/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "844bd0bf38d40f5e593198a0321af515e4ac90af";
